
import React from 'react';

import { Grid, Typography } from '@material-ui/core';
import ManageAudit from '../components/ManageAudit';
import AuditRecipients from '../components/AuditRecipients';

const AuditPage = () => {
    return (
        <div className="o-wrapper" style={{ paddingTop: 20 }}>
            <Typography variant="h5" gutterBottom>Audit</Typography>
            <Typography color="textSecondary">Flagged clinics are automatically rechecked every 10 minutes.</Typography>
            <ManageAudit />
            <Grid container spacing={3} style={{ marginTop: 12 }}>
                <Grid item xs={12} md={6}><AuditRecipients report="issues" /></Grid>
                <Grid item xs={12} md={6}><AuditRecipients report="availability" /></Grid>
            </Grid>
        </div>
    );
};

export default AuditPage;
